import { render } from 'preact';
import { startPolling } from './app/store.ts';
import { App } from './ui/App.tsx';

render(<App />, document.getElementById('root')!);
startPolling();
